/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class InventoryLockApi {
    static getInstance() {
        if (!this.instance) this.instance = new InventoryLockApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取库存锁定列表
    async getList (param){
        let url = `/api/inventory/lock/available`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 库存锁定view列表
    async getViewList (param, page_num, page_size){
        let url = `/api/inventory/lock/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取sku当前库存参考信息
    async getAvailableInventoryListBySKU (param){
        let url = `/api/inventory/lock/available/sku`
        let result = await this.getData(url,param,'GET')
        return result
    } 

    // 
    async getLockAvailableBySKU (param){
        let url = `/api/inventory/lock/lock/available/sku`
        let result = await this.getData(url,param,'POST')
        return result
    }  

    // 获取当前sku下的订单号
    async getOrderBySKU (param){
        let url = `/api/inventory/lock/lock/sku`
        let result = await this.getData(url,param,'GET')
        return result
    } 

    // 获取之前保存的库存占用信息
    async getLockList (param){
        let url = `/api/inventory/lock/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 保存订单库存锁定数据
    async saveInventoryLock (param, order_line_id){
        let url = `/api/inventory/lock/save/${order_line_id}`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 解除当前sku下的库存锁定
    async unlock (order_line_id){
        let url = `/api/inventory/lock/delete/order/line/${order_line_id}?order_line_id=${order_line_id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    } 

    
    // 解除当前sku下的库存锁定
    async exportData (){
        let url = `/api/inventory/lock/available/export`
        let result = await this.getData(url,{},'GET')
        return result
    } 

}

export {
    InventoryLockApi
}